import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";

export default function ContactPage({ fields, errors, handleChange }) {
  const { t } = useTranslation();

  // componentDidMount
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {t("Fill your contact information")}:
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label={t("First name")}
            error={!!errors["firstName"]}
            helperText={errors["firstName"]}
            onChange={(e) => {
              handleChange("firstName")(e.target.value);
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label={t("Last name")}
            error={!!errors["lastName"]}
            helperText={errors["lastName"]}
            onChange={(e) => {
              handleChange("lastName")(e.target.value);
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label={t("Email")}
            error={!!errors["email"]}
            helperText={errors["email"]}
            inputProps={{ type: "email" }}
            onChange={(e) => {
              handleChange("email")(e.target.value);
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label={t("Mobile")}
            error={!!errors["mobile"]}
            helperText={errors["mobile"]}
            placeholder="05xxxxxxxx"
            inputProps={{
              maxLength: 10,
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
            onChange={(e) => {
              handleChange("mobile")(e.target.value);
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
}
